import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PageMeta from './PageMeta';
import { resolvePageMeta } from '../../seo/site';

/** Applies indexable metadata for public routes and noindex for private ones. */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const meta = useMemo(() => resolvePageMeta(pathname), [pathname]);
  if (!meta) return null;
  return <PageMeta {...meta} />;
}
